/* eslint-disable no-param-reassign */

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  isSectionExpanded: false
};

const sendAddToCalendarGA = createAsyncThunk(
  "openHouses/sendAnalytics",
  async (openHouseId, { extra }) => {
    const { analyticsService } = extra;

    analyticsService.sendAddToCalendarEvent({ openHouseId });
  }
);

const uiSlice = createSlice({
  name: "ui",
  initialState,
  reducers: {
    expandSection(state) {
      state.isSectionExpanded = true;
    },
    closeSection(state) {
      state.isSectionExpanded = false;
    }
  }
});

export const { closeSection, expandSection } = uiSlice.actions;

export default uiSlice.reducer;

export { sendAddToCalendarGA };
